const url = require('./dev.uri').BASE_URI;

module.exports = {
  [url]: {
    target:'https://training.bvclss.ndlink.cn',
    // target:'http://localhost:48081',
    changeOrigin: true,
      pathRewrite: {
  ['^' + url]: ''
}
}
}
